import QuerySettings from './QuerySettings';

export default QuerySettings;
